module.exports = __webpack_public_path__ + "static/img/newsimg8.ada74337.jpg";